export const LOGIN_OR_ADDRESS_BOOK_TEXT_FOR_LOGIN =
  'login_or_address_book.login_text';
export const MARKETPLACE_LOGIN_OR_ADDRESS_BOOK_TEXT_FOR_LOGIN =
  'marketplace_login_or_address_book.login_text';
